import { useState } from "react";
import { Col, Row } from "antd";
import AssetPath from "../../AssetPath/AssetPath";
import ModalBox from "../../Components/ModalBox/ModalBox";

export default function AnnualConferenceSpeakers() {
  const [open, setOpen] = useState(false);
  const [showData, setShowData] = useState("");

  const handleShowData = (items) => {
    setShowData(items);
    setOpen(true);
  };

  const SpeakersData = [
    {
      name: "Ankit Jain",
      position: "Co-Founder",
      companyName: "Infinitus Systems, Inc",
      profileImage: AssetPath.annualConference.ankitJain,
      desc: (
        <>
          <p>
            Ankit Jain is the co-founder and company lead of healthcare AI
            company Infinitus Systems, Inc.
          </p>
          <p>
            Jain co-founded Infinitus after having had two successful exits with
            previous mobile intelligence startup Quettra, where he served as CEO
            (acquired by SimilarWeb), and a search engine named Cuil (acquired
            by Google). In between his operator roles, Jain helped launch and
            run Gradient Ventures, Google’s AI venture capital fund.
          </p>
          <p>
            Ankit’s experience as an operator at private and public companies,
            in addition to his experience as an AI investor, gives him a unique
            perspective on how to build and scale foundational AI technologies.
          </p>
        </>
      ),
    },
    {
      name: "Arunkumar Arjunan",
      position: "Chief Technology Officer",
      companyName: "Agilisium",
      profileImage: AssetPath.annualConference.arunkumar,
      desc: (
        <>
          <p>
            Arun Kumar Arjunan serves as the Global Chief Technology Officer at
            Agilisium, based in Thousand Oaks, California, USA. With extensive
            knowledge of emerging technologies, market trends, and a visionary
            approach, Arun leads our technology initiatives, steering our
            solutions lab and driving strategic bets in technology to ensure
            continuous growth and innovation.
          </p>

          <p>
            Since the inception of our company, Arun has been an invaluable
            asset, consistently demonstrating exceptional expertise, leadership,
            and a relentless drive for growth. His unwavering commitment to
            Agilisium and our clients has been pivotal in advancing our
            technological capabilities and contributing to our success. Arun
            fosters a culture of innovation, collaboration, mentorship, and
            continuous learning within the technology team, empowering them to
            deliver cutting-edge solutions.
          </p>
        </>
      ),
    },
    {
      name: "Ashish Patel",
      position: "CEO and Co-Founder",
      companyName: "CareSet",
      profileImage: AssetPath.team.ashishPatel,
    },
    {
      name: "Bala Arunachalam",
      position: "Associate Director - Commercial Insights and Analytics",
      companyName: "Novo Nordisk US",
      profileImage: AssetPath.speakers.balaArunachalam,
      desc: (
        <>
          <p>
            Bala Arunachalam is a seasoned Insights and Analytics (I&A)
            professional with over 15 years of experience in the US pharma,
            having worked with multiple Fortune 500 organizations. He currently
            serves as Associate Director of Insights and Analytics at Novo
            Nordisk US. Bala specializes in data analysis, synthesis,
            integration, and reporting, with a focus on AI/ML applications. His
            commercial expertise spans a range of therapeutic categories,
            including Diabetes, Obesity, CNS, Oncology, and Hemophilia. Bala’s
            passion is to bring innovative analytics solutions to business
            problems, and he excels in guiding teams through challenging
            projects within matrixed organizations. Bala has received numerous
            accolades, including Novo Commercial I&A’s Internal Glory Award for
            fostering innovation and PMSA’s Best Poster Award for a revised NPP
            targeting strategy using ML.
          </p>
          <p>
            Prior to Novo Nordisk, Bala held roles at Bristol Myers Squibb and
            Merck & Co., with I&A projects that significantly impacted strategic
            decisions. Bala brings a background in software engineering with an
            MS in Electrical Engineering from Michigan Technological University
            and an MBA from the University of Michigan.
          </p>
        </>
      ),
    },
    {
      name: "Balaji Viswanathan",
      position: "Global MDM (Master Data Management) Data Product Owner",
      companyName: "Roche",
      profileImage: AssetPath.speakers.BalajiViswanathan,
      desc: (
        <>
          <p>
            Balaji Viswanathan is the Global MDM (Master Data Management) Data
            Product Owner at Roche Genentech, with over 20 years of experience
            in the commercial life sciences industry.
          </p>
          <p>
            With deep expertise in Data Strategy and Data Management, Balaji
            leads the product strategy for Master Data Management, delivering
            innovative capabilities that provide an accurate and 360-degree view
            of the organization's Customers and Products. These capabilities are
            integral to Roche’s Strategic Business Objectives, enabling
            exceptional Omni-Channel Customer Engagement, data-driven
            decision-making, and operational efficiency.
          </p>
          <p>
            Prior to joining Roche Genentech, Balaji held key roles in the life
            sciences consulting industry, where he delivered impactful data
            management solutions for large and medium-sized life sciences
            customers.
          </p>
          <p>
            Balaji holds a Master’s degree in electrical engineering from the
            Indian Institute of Science, Bangalore, India, and an MBA from NYU’s
            Stern School of Business. Outside of work, Balaji enjoys outdoor
            activities like hiking and pursues his passion for photography, with
            a particular interest in astrophotography.
          </p>
        </>
      ),
    },
    {
      name: "Brian Kiep",
      position: "COO",
      companyName: "Valkre Solutions",
      profileImage: AssetPath.speakers.brain,
      desc: (
        <>
          <p>
            Brian has spent over 15 years focusing on the strategies, skills,
            processes, and technologies of Key Account Management. He has worked
            in Life Sciences and many other industries including
            telecommunications, finance, insurance, manufacturing, and
            technology. As a result, he has extensive practical experience
            enabling Account teams to achieve best in class results with their
            most important and strategic customers. Brian is a certified
            instructor for the Strategic Account Management Association (SAMA),
            holds an MBA from the University of Chicago Booth School of Business
            and a BS in Engineering from the University of Illinois at
            Urbana-Champaign.
          </p>
        </>
      ),
    },
    {
      name: "David Ayele",
      position: "Senior Technology Manager",
      companyName: "Rosenblatt Life Science Consultants",
      profileImage: AssetPath.speakers.DavidAyele,
      desc: (
        <>
          <p>
            David is a modeling and forecasting specialist with a strong
            background in science, mathematics, and finance. His expertise lies
            in developing and refining forecasting methodologies, enabling
            high-precision product and market analysis in the life sciences
            industry.
          </p>
          <p>
            David began his career contributing to molecular oncology research
            literature before transitioning into product and market model
            design. His multidisciplinary foundation allows him to build
            intuitive models that maintain high levels of granularity, accuracy,
            and analytical rigor.
          </p>
          <p>
            David holds bachelor's degrees in Physiology and Mathematics from
            McGill University, as well as a degree in Actuarial Mathematics with
            a minor in Finance from Concordia University. He is currently a
            master's candidate in Applied Statistics at Purdue University.
          </p>
        </>
      ),
    },
    {
      name: "Dave Bitner",
      position: "Chief Commercial Officer",
      companyName: "Trio Health",
      profileImage: AssetPath.team.daveBitner,
      desc: (
        <>
          <p>
            Dave has nearly 30 years of experience in commercializing
            pharmaceuticals. Most recently, he spent six years at Komodo Health,
            where he held consulting and business development roles,
            contributing to the company’s rise as a major player in the claims
            data space.
          </p>
          <p>
            Before Komodo, Bitner served as Head of Commercial Operations at
            Intercept Pharmaceuticals, Inc., where he was a key member of the
            Commercial Leadership Team. He supported the rare disease business
            in Primary Biliary Cholangitis (PBC) and helped prepare for the
            launch of their Nonalcoholic Steatohepatitis (NASH) indication.
            Prior to that, he held roles at major pharmaceutical manufacturers,
            including Regeneron Pharmaceuticals Inc., MSD (Europe), Merck & Co.,
            Inc. (US), Amgen Inc., Pfizer Inc./Pharmacia, and NDC Health (now
            Symphony Health Inc). His expertise spans insights and analytics,
            business development and licensing (BD&L), and brand/portfolio
            strategy.
          </p>
          <p>
            David holds bachelor's degrees in Physiology and Mathematics from
            McGill University, as well as a degree in Actuarial Mathematics with
            a minor in Finance from Concordia University. He is currently a
            master's candidate in Applied Statistics at Purdue University.
          </p>
        </>
      ),
    },
    {
      name: "Jane Chen",
      position: "Board Director, Program Committee",
      companyName: "Pharma-SOS",
      profileImage: AssetPath.team.janeChen,
      desc: (
        <>
          <p>
            Jane Chen is a data-driven strategist with 14 years of experience in
            primary and secondary data analytics for optimizing sales in the
            pharma industry's retail, hospital, and LTC sectors.
          </p>

          <p>
            She has extensive expertise in working across matrix team
            structures, collaborating with sales, marketing, regulatory,
            compliance, finance, and legal teams to develop actionable,
            innovative strategies. Her hands-on analytics experience spans
            forecasting, HCP/account targeting, customer segmentation, incentive
            compensation planning, sample optimization, field force design, and
            competitive intelligence.
          </p>

          <p>
            Jane has deep familiarity with pharma data sources, including retail
            scripts, patient claims, formulary data, and market research from
            IQVIA, Definitive, DRG, LexisNexis, First Data Bank, Medispan,
            Syneos, and more.
          </p>
        </>
      ),
    },
    {
      name: "Eric Fitzpatrick",
      position: "Technology Excellence Planning",
      companyName: "Genentech",
      profileImage: AssetPath.annualConference.ericFitzpatrick,
      desc: (
        <>
          <p>
            Eric Fitzpatrick has an Electrical Engineering degree from San
            Francisco State and serves as the Senior Planning Lead on the Access
            Solutions Technology Excellence team at Genentech. During his 14
            year tenure at Genentech, Eric has been integral in supporting an
            array of large-scale system deployments and vendor integrations. His
            expertise has ensured the effective execution of complex technology
            projects across the organization. Currently, Eric is focused on
            enhancing the company's AI capabilities for Patient
            Support services.
          </p>
        </>
      ),
    },
    {
      name: "Khushtar Pandit",
      position: "Healthcare Ecosystems Data and Tech Lead ",
      companyName: "ZS",
      profileImage: AssetPath.annualConference.KhushtarPandit,
      desc: (
        <>
          <p>
            Khushtar Pandit is a leader in Healthcare Ecosystems Technology at
            ZS Associates, driving innovation and technological advancements in
            organized customer engagement for life sciences. With a focus on
            building comprehensive account enablement ecosystems, she has helped
            life sciences organizations enhance their key account management
            (KAM) strategies through the integration of cutting-edge tools, data
            analytics, and AI-powered insights. With deep expertise in
            leveraging data, tools, and processes, she drive strategic
            innovations that enhance key account performance and client
            engagement across complex healthcare landscapes.
          </p>
          <p>
            Based in New York, Khushtar holds an MBA from Columbia Business
            School in Strategy and Product Innovation.
          </p>
        </>
      ),
    },
    {
      name: "Kevin Possley",
      position: "Engagement Lead, Analytics",
      companyName: "ProcDNA",
      profileImage: AssetPath.speakers.KevinPossley,
      desc: (
        <>
          <p>
            Kevin brings over a decade of experience within the healthcare
            industry, specializing in life science consulting. His expertise
            spans pre- and post-commercial solutions across a diverse range of
            therapeutic areas, including immunology, oncology, neurology,
            dermatology and rare diseases.
          </p>
        </>
      ),
    },
    {
      name: "Jane Urban",
      position: "Vice President, Customer Engagement Operations",
      companyName: "Otsuka",
      profileImage: AssetPath.speakers.janeUrban,
      desc: (
        <>
          <p>
            Jane Urban is a seasoned leader in biopharma commercialization,
            specializing in building high-performing teams and integrating data,
            analytics, and omnichannel strategies to enhance customer
            engagement. As VP of Customer Engagement Operations at Otsuka
            Pharmaceuticals, she unifies data, analytics, omnichannel, and field
            operations to optimize customer experience.
          </p>
          <p>
            Previously, Jane was VP of Data, Digital & Technology for Global
            Commercial & Medical at Takeda, where she led US Commercial Data,
            integrated operations post-Shire acquisition, and built data
            capabilities for Entyvio, a key brand. With 15+ years in biopharma
            and 10+ years in team leadership, she has held analytics,
            forecasting, digital marketing, and commercial operations roles
            across pharma and consulting.
          </p>
          <p>
            Jane holds an MBA from Kellogg (Northwestern University) and a
            Biomedical Engineering & Economics degree from Brown University.
          </p>
        </>
      ),
    },
    {
      name: "John W. Keon",
      position: "President",
      companyName: "The Marketing Advantage, Inc.",
      profileImage: AssetPath.speakers.johnwKeon,
      desc: (
        <>
          <p>
            Dr. John W. Keon is a prominent figure in the field of Artificial
            Intelligence and Sales Incentive Compensation Design. He holds a
            dual Ph.D. from Wharton and has over 35 years of experience in
            BioPharma sales compensation design. Dr. Keon is the founder of The
            Marketing Advantage®, Inc., where he has been instrumental in
            developing innovative solutions for sales compensation and sales
            optimization.
          </p>
          <p>
            {" "}
            His work includes leveraging advanced AI technologies, including
            generative AI and multimodal capabilities, to enhance sales
            compensation plans and provide valuable insights through The
            Marketing Advantage’s Momentum™ system
          </p>
        </>
      ),
    },
    {
      name: "Marady Hill",
      position: "Executive Coach",
      companyName: "Korn Ferry",
      profileImage: AssetPath.annualConference.maradyHill,
      desc: (
        <>
          <p>
            <strong>30+ Years of Leadership Experience:</strong> Expert in
            transformation leadership, executive coaching, and cultural
            transformations with global experience across industries like
            technology, biotech, and entertainment.
          </p>
          <p>
            <strong>Certified Coach & Practitioner:</strong> Holds
            certifications including Korn Ferry Enterprise Coach, Certified
            Scrum Master (CSM), and Prosci Change Practitioner.
          </p>
          <p>
            <strong>Specialized Coaching Expertise:</strong> Focus on agile
            transformations, sales leadership, AI-driven change, innovation
            programs, and organizational strategy.
          </p>
          <p>
            <strong>Global & Cross-Cultural Adaptation:</strong> Coached leaders
            worldwide, including expat assignments, with proficiency in Japanese
            and a 98% cross-cultural adaptation rate.
          </p>
          <p>
            <strong>High-Impact Client Results:</strong> Coached C-suite leaders
            in biotech, life sciences, and pharma to improve leadership
            presence, stakeholder engagement, and global strategy.
          </p>
          <p>
            <strong>Creative & Practical Approach:</strong> Combines creative
            experience as a Disney Imagineering producer with query-based
            coaching to elevate leaders' growth and mindset shifts.
          </p>
        </>
      ),
    },
    {
      name: "Michael Karbachinskiy",
      position: "Founder & CEO",
      companyName: "KMK Consulting",
      profileImage: AssetPath.annualConference.MichaelKarbachinskiy,
      desc: (
        <>
          <p>
            Michael is the Founder & CEO of KMK Consulting, Inc. Michael is an
            expert in targeting, promotional evaluation, and technology and data
            warehouse design. He has been an instrumental force in designing and
            executing the Novartis Marketing Science data warehouse structure,
            campaign ROI evaluation, and overall analytics support.
          </p>
          <p>
            For the last 25 years KMK has provided support and guidance in
            marketing analytics, sales force effectiveness, sales operations and
            HEOR/RWE to numerous companies in life science ranging from biotech
            startups to some of the biggest names in pharma{" "}
          </p>
          <p>
            Previously, Michael was in charge of statistical development
            programming at AT&T and was responsible for setting up financial and
            marketing programming design and evaluation for credit card
            portfolios for several large banks.
          </p>
        </>
      ),
    },

    {
      name: "Nishant Zope",
      position: "Data Scientist",
      companyName: "Novo Nordisk",
      profileImage: AssetPath.speakers.nishantZope,
      desc: (
        <>
          <p>
            Nishant Zope is a seasoned Data Scientist, with over 8 years of
            experience in the field of data science and advanced analytics.
          </p>
          <p>
            In his current role at Novo Nordisk, Nishant leads the design and
            development of advanced AI/ML-driven capabilities for patient and
            HCP level analytics across therapeutic areas. With expertise in
            traditional machine learning, generative AI and end-to-end product
            implementation, he has been effectively facilitating diverse
            commercial use cases to drive commercial growth and improve patient
            outcomes.
          </p>
          <p>
            Nishant holds an MS in Information Technology, specializing in data
            science from Rensselaer Polytechnic Institute and a BS in Computer
            Engineering from Institute of Engineering and Technology, India.
          </p>
        </>
      ),
    },
    {
      name: "Nik Kashyap",
      position: "Global Head of Pharma Commercial Data & Insights IT",
      companyName: "Genentech",
      profileImage: AssetPath.speakers.NikKashyap,
      desc: (
        <>
          <p>
            Nik Kashyap is a visionary leader in AI, data, and digital
            transformation, serving as the Global Head of Pharma Commercial Data
            & Insights, IT at Genentech and Roche.
          </p>
          <p>
            He drives the global strategy and execution across the United
            States, China, and the rest of the world, transforming how data, AI,
            and advanced analytics fuel the future of healthcare.
          </p>
          <p>
            Nik has led several strategic initiatives to unlock the strategic
            value of data investments, embedding a data-driven culture and
            pioneering innovations such as Next Best Action intelligence,
            AI-driven competitive insights, and revenue simulation platforms to
            drive value for the enterprise.
          </p>
          <p>
            Our team's work fosters a profound impact on both Genentech and
            Roche, enhancing data-driven decision-making in the healthcare
            sector.
          </p>
        </>
      ),
    },
    {
      name: "Prakash Karaka",
      position: "Chief AI Officer",
      companyName: "Chryselys",
      profileImage: AssetPath.speakers.prakashKaraka,
      desc: (
        <>
          <p>
            As Chief AI Officer, Prakash is a guide and a collaborator with
            ethics and governance in mind. His focus is on integrating AI and
            Generative AI technologies, steering Chryselys’ vision towards
            harnessing vast datasets and yielding novel insights & solutions.
            This involves leveraging AI’s predictive capabilities and GenAI’s
            creative potential to revolutionize solutions to address client
            needs.
          </p>
          <p>
            With a deep commitment to leveraging technology for healthcare
            advancement, Prakash brings over 17 years of experience in
            engineering, AI, data analytics, and machine learning to the
            pharmaceutical management science field.
          </p>
          <p>
            Prakash is at the forefront of developing AI solutions that are
            secure, personalized, and transformative for the Pharma industry.
            His roles at Amazon, Microsoft, and Intel have been marked by
            significant contributions in areas ranging from cloud-based big data
            analytics to AI-driven retail and developer services.
          </p>
          <p>
            Prakash earned a Bachelor of Engineering in Electronics and
            Communications from Andhra University, India.
          </p>
        </>
      ),
    },
    {
      name: "Ricardo Uribe",
      position: "Principal Head of Technology",
      companyName: "Rosenblatt Life Science Consultants",
      profileImage: AssetPath.speakers.RicardoUribe,
      desc: (
        <>
          <p>
            Ricardo is a computer scientist and business simulation expert,
            recognized as a global thought leader in market model architecture.
            He specializes in designing and constructing Excel-based models that
            accurately predict product dynamics in the life sciences industry.
          </p>
          <p>
            With a background spanning logistics, forecasting, and academia,
            Ricardo has held key roles at Air Canada as a Logistics Modeler, IMS
            Health Consulting as a Forecasting Analyst, and EAFIT University as
            an Engineering Professor.
          </p>
          <p>
            His contributions to the field include originating mathematical
            models that set a new industry standard for patient switching
            dynamics and authoring innovative formulae that enhanced the
            accuracy of compliance curves in incidence modeling. Ricardo holds
            an MBA from McGill University and a bachelor's in Engineering from
            EAFIT University.
          </p>
        </>
      ),
    },
    {
      name: "Rohit Marwah",
      position: "AVP – Advanced Analytics And Insights",
      companyName: "Defintive Healthcare",
      profileImage: AssetPath.speakers.rohitMarwah,
      desc: (
        <>
          <p>
            ~15 years of experience managing and leading commercial analytics,
            health economics research, and real-world data strategy, and
            consulting for life sciences, payers, and providers
          </p>
          <p>
            Expertise in the application of AI and machine learning including
            NLP for various biopharma use cases, including rare disease patient
            findings, cancer staging, precision medicine, patient and physician
            engagement, personalized triggers, data imputations, and risk
            analytics
          </p>
          <p>Clarivate, DRG, Indegene, DRDO</p>
          <p>Double Masters in Biotechnology and Bioinformatics</p>
        </>
      ),
    },
    {
      name: "Sai Rithvik Kanakamedala",
      position: "Data Scientist, Advanced Analytics",
      companyName: "Novo Nordisk",
      profileImage: AssetPath.annualConference.saiRithvik,
      desc: (
        <>
          <p>
            Sai Rithvik Kanakamedala is a Data Scientist at Novo Nordisk with a
            strong academic background and hands-on experience in advanced
            analytics and machine learning. His work involves development of
            data pipelines and predictive models to enhance HCP targeting
            strategies.
          </p>
          <p>
            Sai has demonstrated expertise in deploying AutoML processes,
            achieving significant efficiency gains, and creating impactful
            machine learning models. With a master's in data science from
            Columbia University and a bachelor's degree from IIT Madras, Sai
            Rithvik has contributed to academic research, publishing work on
            neural network architectures, and has experience in healthcare and
            artificial intelligence research.
          </p>
        </>
      ),
    },
    {
      name: "Sayantan Dasgupta",
      position: "Director, Commercial Analytics",
      companyName: "Arvinas",
      profileImage: AssetPath.speakers.SayantanDasgupta,
      desc: (
        <>
          <p>
            Sayantan Dasgupta is the Director of Commercial Analytics at
            Arvinas, where he oversees all aspects of secondary data analytics,
            including market sizing, market share analysis, segmentation,
            targeting, and field operations. He is responsible for developing
            and implementing comprehensive data strategies that build a robust
            infrastructure, ensuring data-driven insights inform business
            decisions. With over a decade of industry experience, Sayantan
            brings deep expertise in empowering commercial teams to make
            strategic decisions that drive successful brand positioning and
            market growth.
          </p>
          <p>
            He has played a pivotal role in supporting brand teams with label
            expansion and new drug launches by evaluating target populations and
            optimizing resource utilization. Additionally, Sayantan has provided
            critical support to Market Access teams, identifying contractual
            opportunities with providers while minimizing GTN impact. His
            expertise in data analytics has been instrumental in driving
            informed decision-making across various commercial functions.
          </p>
        </>
      ),
    },
    {
      name: "Shan Yeh",
      position: "Board Director Pharma-SOS, 2025 Conference Chair",
      profileImage: AssetPath.team.shanYeh,
      desc: (
        <>
          <p>
            Shan Yeh is a seasoned operations leader with over 15 years of
            experience in pharmaceutical and biotechnology commercial
            operations. Shan currently advises clients on market access
            strategy, commercial operations, and technology investments to
            enhance business processes and customer engagement.
          </p>
          <p>
            Previously, Shan was Senior Director of Medical and Access
            Operations and Analytics at Jazz Pharmaceuticals, where he led teams
            to improve patient experience, optimize distribution networks, and
            implement CRM solutions across multiple product launches. Prior to
            that, he held leadership roles at Genentech, driving efficiencies in
            patient services, contact centers, and digital engagement.
          </p>
          <p>
            Shan holds an MBA from Stanford Graduate School of Business and a BS
            in Chemical Engineering from UC Berkeley. He is recognized for his
            strategic leadership, cross-functional collaboration, and expertise
            in optimizing patient access and operational excellence.
          </p>
        </>
      ),
    },
    {
      name: "Subrat Mishra",
      position: "Lead Data Scientist",
      companyName: "Definitive Healthcare",
      profileImage: AssetPath.speakers.subratMishra,
      desc: (
        <>
          <p>
            Subrat Mishra is a data science expert with a specific focus on
            natural language processing, generative AI, graph algorithms, and
            various facets of advanced machine learning. With more than 13 years
            of experience, he has adept leadership in managing computing and
            data science teams, effectively leveraging complex real-world data
            to drive innovative solutions and insights.
          </p>
          <p>
            He is a Lead Data Scientist helping address and solve intricate
            business challenges with the application of cutting-edge AI/ML
            techniques. He holds a master's degree in computer science, with a
            specialization in advanced machine learning algorithms.
          </p>
        </>
      ),
    },

    {
      name: "Samik Adhikary",
      position: "Head of Analytics Products and Services",
      companyName: "Roche",
      profileImage: AssetPath.speakers.SamikAdhikary,
      desc: (
        <>
          <p>
            Samik Adhikary is an experienced leader in data and analytics, adept
            at guiding teams to leverage data for strategic decision-making.
            With a robust background in artificial intelligence and machine
            learning, he has implemented innovative solutions across various
            industries and has several patents in this this field. At Roche,
            Samik is responsible to drive and scale AI solutions in the
            commercial domain across 100+ countries and global teams. His
            international experience provides a global perspective to his
            projects and collaborations. With innovation at the core Samik
            brings a blend of business and technical knowledge to drive impact.
          </p>
        </>
      ),
    },
    {
      name: "Suzanne Marzziotti",
      position: "Head, Business Solutions",
      companyName: "Chryselys",
      profileImage: AssetPath.speakers.suzanneMarzziotti,
      desc: (
        <>
          <p>
            With over 30 years of enriching the pharmaceutical and CPG
            industries with actionable insights, Suzanne Marziotti spearheads
            the business solutions vertical at Chryselys. In her role as Head of
            Business Solutions, she strategically applies data to catalyze
            growth and customize solutions that align with the complex needs of
            the pharma industry.
          </p>

          <p>
            Suzanne’s professional journey is marked by a strong emphasis on
            precision medicine reporting and commercial analytics, fostering the
            use of generative AI to enhance predictive modelling across
            therapeutic domains.
          </p>
          <p>
            Her approach weaves together cutting-edge technology and in-depth
            industry knowledge, resulting in robust strategies that elevate both
            client experience and patient care.
          </p>
          <p>
            Suzanne holds a BS in Microbial Genetics from Cornell University,
            complemented by an MBA from NYU’s Stern School of Business, which
            has empowered her to merge scientific inquiry with strategic
            implementation.
          </p>
        </>
      ),
    },
    {
      name: "Vishal Janani",
      position: "VP of Life Science Consulting",
      companyName: "Agilisium",
      profileImage: AssetPath.annualConference.vishal,
      desc: (
        <>
          <p>
            Vishal Janani is a seasoned Life Sciences Consulting leader with
            over 19 years of experience delivering Digital solutions and driving
            operational transformation across the Life Sciences value chain.
            Currently serving as Vice President at Agilisium, Vishal specializes
            in clinical trial operations, commercial operations, and
            pharmacovigilance, helping organizations optimize their business
            processes through technology-driven solutions.
          </p>

          <p>
            In his previous role as Director of Product Management at Cognizant
            Technology Solutions, he led the Life Sciences product strategy,
            spearheading the first industry-wide sponsor-site collaboration
            platform with over 370K+ users. He also contributed to launching the
            commercial mobile app and played a key role in establishing new
            service lines for the product platform.
          </p>
        </>
      ),
    },
    {
      name: "Zheng Liu",
      position: "Associate Director, Quantitative Research",
      companyName: "Novartis",
      profileImage: AssetPath.speakers.Zheng,
      desc: (
        <>
          <p>
            Zheng Liu is a seasoned professional specializing in insights
            generation and advanced analytics within the pharmaceutical and life
            sciences industries. With over 6 years of experience and a strong
            scientific background, Zheng has a proven track record of driving
            commercial strategy development and implementation.
          </p>
          <p>
            Currently serving as the Associate Director of Quantitative Research
            at Novartis, Zheng leads performance analytics and supports
            commercial launches across various indications. His role involves
            conducting in-depth analyses of global commercial data, preparing
            forecasts for late-stage assets, and leveraging advanced analytics
            and GenAI tools for primary market research insights. Zheng's
            innovative use of GenAI has significantly shortened insight
            generation time, while also increasing accuracy and reducing bias
            from the analysis.
          </p>
          <p>
            Zheng holds a Ph.D. in Biomedical Engineering from the University of
            Rochester.
          </p>
        </>
      ),
    },
  ];

  return (
    <>
      <section
        className="speakers our-team spacing position-relative bg-light-green"
        data-aos="fade-up"
      >
        <div className="container">
          <div className="d-flex flex-column flex-md-row flex-lg-row align-items-center justify-content-between">
            <div className="text-center w-100">
              <h4 className="title mb-3 text-primary fw-bold text-center">
                Meet the Speakers
              </h4>
            </div>
          </div>
          <div className="team-list">
            {/* <Carousel {...carouselConfig} ref={carouselRef}> */}
            <Row
              gutter={[
                { xs: 0, sm: 3, md: 3, lg: 3 },
                { xs: 0, sm: 0, md: 0, lg: 0 },
              ]}
            >
              {SpeakersData.map((members, i) => (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 8 }}
                  lg={{ span: 6 }}
                  key={i}
                >
                  <div
                    className="team-details position-relative cursor-pointer"
                    onClick={() => handleShowData(members)}
                  >
                    <div className="profile-image rounded overflow-hidden">
                      <img
                        src={members.profileImage}
                        alt={members.name}
                        className="w-100 rounded"
                      />
                    </div>
                    <div className="details text-center card">
                      <h4 className="font-4 font-weight-bold mb-1">
                        {members.name}
                      </h4>
                      <p className="text-ellipsis2 mb-0">
                        {members.companyName || members.position}
                      </p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
            {/* </Carousel> */}
          </div>
        </div>
      </section>

      <ModalBox
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
      >
        <div className="speaker-profile-informations">
          <Row
            gutter={[
              { xs: 0, sm: 16, md: 24, lg: 32 },
              { xs: 0, sm: 16, md: 24, lg: 20 },
            ]}
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 9 }}
              lg={{ span: 9 }}
            >
              <div className="profile-image rounded overflow-hidden">
                <img
                  src={showData.profileImage}
                  alt={showData.name}
                  className="w-100 rounded"
                />
              </div>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 15 }}
              lg={{ span: 15 }}
            >
              <div className="details text-left p-0">
                <h4 className="text-primary mb-1 border-bottom pb-2 mb-3">
                  <span className=" font-weight-bold">{showData.name}</span>
                  <span className="font-2 fon-weight-normal text-primary d-block">
                    {showData.position}
                    {showData.position && showData.companyName ? ", " : ""}
                    <strong>{showData.companyName}</strong>
                  </span>
                </h4>

                <div className="profile-desc">{showData.desc}</div>
              </div>
            </Col>
          </Row>
        </div>
      </ModalBox>
    </>
  );
}
